import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a9426c02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9426c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9426c02')) {
      api.createRecord('a9426c02', component.options)
    } else {
      api.reload('a9426c02', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a9426c02&scoped=true", function () {
      api.rerender('a9426c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/businessAddress/index.vue"
export default component.exports